<template>
  <div class="user-avatar-button">
    <LlAvatar
      :image="C_image.url"
      :circle-size="80"
      @click="$_previewPopUpOpen()"
    />
    <div
      v-if="!displayOnly"
      class="user-avatar-button_upload-input"
    >
      <RoundButton
        icon="icon-camera"
        @click="$_handleUploadBtnClick()"
      />
      <input
        ref="fileInput"
        type="file"
        accept="image/*"
        @change="$_onChange($event)"
      >
    </div>
    <PreviewPopUp
      :pop-up-active="previewPopUpActive"
      :text-label="C_image.url && !C_image.isloading ? C_image.url : noImage"
      download
      @click="$_previewPopUpClose()"
    />
  </div>
</template>
<script>
export default {
  name: "UserAvatarButton",
  props: {
    image: {
      type: String,
      default: "",
    },
    displayOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    previewPopUpActive: false,
    C_image: {},
    noImage: require("@/assets/image/avatar.svg"),
    uploadUrl: "/auth/user/avatar/",
  }),
  watch: {
    image() {
      this.C_image = { url: this.image };
    },
    C_image: {
      handler() {
        if (this.C_image.isloading === false) {
          this.$_setValue();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.C_image = { url: this.image };
  },
  methods: {
    $_handleUploadBtnClick() {
      this.$refs.fileInput.click();
    },
    $_previewPopUpClose() {
      this.previewPopUpActive = false;
    },
    $_previewPopUpOpen() {
      if (!this.C_image.url && !this.C_image.isloading) return;
      this.previewPopUpActive = true;
    },
    $_fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    $_handleUploadProgress(progressEvent, target) {
      target.percent = Math.round(
        (progressEvent.loaded / progressEvent.total) * 10
      );
    },
    async $_onChange($event) {
      const file = $event.target.files[0];
      const base64 = await this.$_fileToBase64(file);
      this.C_image = {
        percent: 0,
        isloading: true,
        url: base64,
        file: file,
      };
      await this.$axios
        .put(`${this.uploadUrl}${file.name}`, file, {
          onUploadProgress: (progressEvent) =>
            this.$_handleUploadProgress(progressEvent, this.C_image),
        })
        .then((res) => {
          this.C_image.url = res.data.signed_url;
          this.C_image.percent = 0;
          this.C_image.isloading = false;
          this.$store.dispatch("stone_auth/setCurrentUser", {
            ...this.$store.state.stone_auth.currentUser,
            avatar: res.data.signed_url,
          });
        });
      try {
        await this.$axios.patch('auth/user', {
            "avatar": this.C_image.url
          })
      } catch (error) {
        alert(error)
      }
    },
    async $_setValue() {
      try {
        await this.$axios.patch(`/auth/user`, {
          avatar: this.C_image.url,
        });
      } catch (err) {
        alert(this.$t("更新頭像失敗"));
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/user-avatar-button";
</style>